import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageSquarePlus } from 'lucide-react';
import FeedbackModal from './FeedbackModal';

// 不显示反馈按钮的页面路径
const HIDE_FEEDBACK_PATHS = ['/loading', '/interview', '/salary-negotiation'];

export default function FeedbackButton() {
  const [modalOpen, setModalOpen] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const location = useLocation();

  // 判断当前页面是否需要隐藏反馈按钮
  const shouldHideFeedback = HIDE_FEEDBACK_PATHS.some((path) =>
    location.pathname.startsWith(path),
  );

  // 如果在隐藏列表中，不渲染组件
  if (shouldHideFeedback) {
    return null;
  }

  return (
    <>
      {/* 悬浮反馈按钮 */}
      <button
        onClick={() => setModalOpen(true)}
        onMouseDown={() => setIsPressed(true)}
        onMouseUp={() => setIsPressed(false)}
        onMouseLeave={() => setIsPressed(false)}
        className={`
          fixed bottom-6 right-2 z-40
          w-14 h-14 rounded-full
          flex items-center justify-center
          cursor-pointer
          transition-all duration-200 ease-out
          ${isPressed ? 'scale-95' : 'hover:scale-105'}
        `}
        style={{
          background:
            'linear-gradient(135deg, #f59e0b 0%, #d97706 50%, #b45309 100%)',
        }}
        aria-label="提交反馈"
      >
        {/* 图标 */}
        <MessageSquarePlus
          size={26}
          className="text-white drop-shadow-md"
          strokeWidth={2}
        />
      </button>

      {/* 反馈弹窗 */}
      <FeedbackModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
